import base64 from 'base-64';
import * as Either from 'data.either';
import uft8 from 'utf8';
import isString from 'lodash/isString';

// Either docs: http://folktalegithubio.readthedocs.io/en/latest/api/data/either/Either.html

/*
(...) => Either[error, object]
 */
export function readLocalStorage(key) {
  return Either.fromNullable(localStorage.getItem(key))
    .map(JSON.parse)
    .leftMap((err) => {
      // parsing error, null for empty storage
      if (null !== err) {
        console.warn('Error parsing local storage value');
        console.warn(err);
      }
      return err;
    });
}

/*
 (...) => Either[error, T], T is not nullable
 */
export function readUserVar(key, userEmail) {
  return readLocalStorage(key)
    .chain(Either.try((storage) => storage[userEmail]))
    .chain(Either.fromNullable);
}

/* (...) => boolean */
export function getUserFlag(userEmail, key, defaultValue = false) {
  return readUserVar(key, userEmail).map(Boolean).getOrElse(defaultValue);
}

export function setUserFlag(userEmail, key, value) {
  const storage = readLocalStorage(key).getOrElse({});
  storage[userEmail] = value;
  localStorage.setItem(key, JSON.stringify(storage));
}

const GLOBAL_VARIABLES_STORAGE_NAME = 'FHT_GLOBAL';
const NO_WINDOW_GLOBAL = {};

export function getFhtGlobalScope() {
  const globalScope = window || NO_WINDOW_GLOBAL;
  return Either.fromNullable(globalScope[GLOBAL_VARIABLES_STORAGE_NAME])
    .orElse(() => {
      const container = {};
      globalScope[GLOBAL_VARIABLES_STORAGE_NAME] = container;
      return Either.of(container);
    })
    .get();
}

// (str) -> Either[null|undefined,  T]
function getFromDom(name) {
  return Either.fromNullable(
    document.querySelector(`input[name="${name}"]`)
  ).chain((input) => decodeVar(input.value));
}

// (str) => Either[nullable | err, T]
export function decodeVar(value) {
  return Either.fromNullable(value)
    .chain(Either.try(base64.decode))
    .chain(Either.try(uft8.decode))
    .chain(Either.try(JSON.parse));
}

// (T) => Either[nullable | err, T]
function encodeVar(value) {
  // We replace undefined with null, since we will use JSON
  return Either.fromNullable(value)
    .orElse(Either.of(null))
    .chain(Either.try(JSON.stringify))
    .chain(Either.try(uft8.encode))
    .chain(Either.try(base64.encode));
}

export function setToDOM(setter, value) {
  encodeVar(value).map(setter).leftMap(console.warn);
}

export function getFhtGlobal(name) {
  return Either.fromNullable(getFhtGlobalScope()[name])
    .orElse(() => getFromDom(name))
    .getOrElse(null);
}

export function setFhtGlobal(name, value) {
  getFhtGlobalScope()[name] = value;
}

export function lodashIsString(value) {
  return isString(value);
}
